import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [receiverId, setReceiverId] = useState(null);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  const openChatWithReceiver = (id) => {
    setReceiverId(id);
    setIsChatOpen(true);
  };

  return (
    <ChatContext.Provider
      value={{
        isChatOpen,
        toggleChat,
        receiverId,
        setReceiverId,
        openChatWithReceiver,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);
